module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_VIRTUAL_3_B-e4a86a0202c1d99c5c66d4d657f3c551.gif";